<template>

    <data-variable-base :value="value" :variable="variable" @delete="emitDelete(variable)">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <validation-provider
                name="Date"
                rules="required|numeric"
                v-slot="{ errors }">

                <v-text-field
                    v-show="!isMasked"
                    v-model="answer"
                    :label="variable.name.replace('_',' ')"
                    placeholder="Placeholder"
                    :disabled="isDisabled"
                    :persistent-hint="!!hint"
                    :hint="hint"
                    :hide-details="!hint && errors.length === 0 && !errorMessages[variable.name]"
                    :error-messages="errors.length > 0 ? errors : errorMessages[variable.name]"
                    class="flex-grow-1"
                ></v-text-field>

            </validation-provider>

        </validation-observer>

    </data-variable-base>
</template>

<script>

import {dataVariableInputMixin} from './dataVariableInputMixin';
import MaskedField from './MaskedField';
import DataVariableBase from "./DataVariableBase";

export default {

    mixins: [dataVariableInputMixin],

    components: {
        DataVariableBase,
        MaskedField
    },

    props: {
        value: {
            type: Number | null,
            required: true
        },
    },

    watch: {
        value(value) {
            this.model = value;
        },
        model(newValue, oldValue) {
            // Actual validation is done inside mixin!
            // Emit changed values only
            if (oldValue !== newValue && oldValue !== null) this.emit(newValue);
        },
    },

    computed: {

        answer: {
            get() {
                return this.model;
            },
            set(value) {
                this.model = value;
            }
        }
    },
}
</script>
